import type { NavItem, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const CDN_URL = 'https://coral-bison-222.cdn.modulify.website'

export const siteConfig: SiteConfig = {
    name: 'Iza Faroza',
    shortName: 'Izfrza',
    role: 'Web Developer & Pembina Pramuka',
    description: 'Portofolio Iza Faroza, mahasiswa Ilmu Komputer STIKOM El Rahma Bogor dan web developer yang menggabungkan dunia teknologi dengan keterampilan kepemimpinan sosial.',
    url: getOrigin(),
    ogImage: `${CDN_URL}/portfolio/photos/iza-formal-red.jpg`,
    email: 'izafaroza0@gmail.com',
    phone: '+62 895 4023 57182',
    phoneHref: 'tel:+62895402357182',
    whatsappHref: 'https://wa.me/62895402357182',
    cvHref: 'https://drive.google.com/file/d/1GCfkVw5yeGL17sYQZqiHiGL2eSjyK6lr/view?usp=sharing',
    hours: 'Balasan dalam 1x24 jam',
    founded: '2022',
    location: {
        city: 'Bogor',
        region: 'Jawa Barat',
        country: 'Indonesia'
    },
    socials: [
        { label: 'Instagram', href: 'https://www.instagram.com/izfrza' },
        { label: 'GitHub', href: 'https://github.com/Izfrza' },
        { label: 'LinkedIn', href: 'https://www.linkedin.com/in/iza-faroza-7745b2360' },
        { label: 'WhatsApp', href: 'https://wa.me/62895402357182' }
    ]
}

export const navigation: NavItem[] = [
    { label: 'Beranda', href: '/' },
    { label: 'Proyek', href: '/projects' },
    { label: 'Tentang', href: '/about' },
    { label: 'Sertifikat', href: '/certificates' },
    { label: 'Kontak', href: '/contact' }
]

export const legalNavigation: NavItem[] = [
    { label: 'Syarat Penggunaan', href: '/terms-of-services' },
    { label: 'Kebijakan Privasi', href: '/privacy-policy' }
]

export const categories = ['Sistem Informasi', 'Website', 'Karya Tulis'] as const
